<template>
  <div class="app-main-content">
    <!-- 需要在切换回来后，页面保持不变，所以使用v-show -->
    <booking-tree-grid
      v-show="view==='list'"
      ref="bookingTreeGrid"
      :view="view"
      :context="context"
      :is-sales-for-szfs="isSalesForSzfs"
      @look="lookHandle"
      @edit="editHandle"
      @copy="copyHandle"
      @add="addHandle"
      @lockJob="lockFormEventBatch"
      @submitJob="submitFormEventBatch"
    />
    <!-- 因为占用内存多，所以使用v-if，每次需要使用时都重新创建 -->
    <booking-workspace
      v-show="view==='detail'"
      ref="bookingWorkspace"
      :parent-context="context"
      :is-sales-for-szfs="isSalesForSzfs"
      @edit="editHandle"
      @copy="copyHandle"
      @add="addHandle"
      @lockJob="lockFormEvent"
      @submitJob="submitFormEvent"
      @back="backToList"
    />
    <!--业务复制选择复制哪些信息（lob传一个唯一的名称，用于与其他业务区分）-->
    <job-copy-window :visible.sync="copyDialog.visible" lob="remoteBooking" @confirmCallBack="doCopyJob" />
    <job-no-rule-selector
      :visible.sync="jobNoRule.visible"
      :rules="jobNoRule.rules || []"
      @selectedBack="doCopyJob"
    />
    <!-- 铁路业务类型选择 -->
    <el-dialog
      v-if="railwayLobDialog.visible"
      v-el-drag-dialog
      :visible.sync="railwayLobDialog.visible"
      :title="$t('CargoMsg.Cargo_BusinessType')"
      :width="$selectByLang('300px', '300px', '300px', '400px', '400px', '400px')"
      :close-on-click-modal="false"
      class="app-main-inner"
      @close="railwayLobDialog.visible=false"
    >
      <div class="app-main-inner-row" style="flex-direction: column;padding-bottom: 10px;">
        <el-radio-group v-model="railwayLobDialog.lob">
          <el-radio no="RE" label="RE">{{ $t('CargoMsg.Cargo_Export') }}</el-radio>
          <el-radio no="RI" label="RI" style="margin-left: -20px;">{{ $t('CargoMsg.Cargo_JobTypeImport') }}</el-radio>
        </el-radio-group>
      </div>
      <div slot="footer">
        <el-button no="Confirm" type="primary" @click="confirmRailwayLobHandler">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
        <el-button no="Cancel" @click="() =>{railwayLobDialog.visible=false}">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 多条业务 配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :lob="checkRow.lob"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
    />
    <!-- 单条业务 配置规则验证弹窗-->
    <checking-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      :lob="checkRow.lob"
      :job="checkRow"
      :check-node="checkingWindow.checkNode"
      :call-back="checkingWindow.callBack"
      :call-back2="checkingWindow.callBack2"
    />
  </div>
</template>

<script>
import { RemoteBookingContext } from './remoteBookingContext'
import bookingTreeGrid from './components/remoteBooking/bookingTreeGrid.vue'
import bookingWorkspace from './components/remoteBooking/bookingWorkspace.vue'
import jobCopyWindow from '@/components/Cargo/Job/jobCopyWindow'
import jobNoRuleSelector from '@/components/Cargo/Job/jobNoRuleSelector'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import CheckingWindow from '@/components/Cargo/Job/CheckingManager/CheckingWindow'
import { ErrorTip } from '@/utils/class/ErrorTip'
import LocalStorageUtils from '@/utils/localStorageUtils'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { Job } from '@/class/model/booking/Job'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { isContractExpiredForbidCreateJob, doCopyJob as doCopySeJob, saveSeaBookingSpace } from '@/api/seaExport/seaExportJob'
import { doCopyJob as doCopyAeJob, saveAeBookingSpace } from '@/api/AirExport/airExportJob'
import { doCopyJob as doCopyRailwayJob, saveRailwayExport } from '@/api/railwayExport/reBooking'
import { getUserDefaultDepartment } from '@/api/user'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { EntityDefaultValueUtil } from '@/class/cargo/model/utils/EntityDefaultValueUtil'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import lodash from 'lodash'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import {
  batchUpdatePreVerifyState,
  batchUpdatePreVerifyStateAndJobState,
  remoteBookingQuery
} from '@/api/booking/job'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { cache, cacheName } from '@/utils/cacheManager'
import { INTELLIGENT_DOCUMENT_SOURCE_REMOTE_AE } from '@/class/cargo/model/parameters/SystemConstants'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'

export default {
  name: 'RemoteBooking',
  components: { bookingTreeGrid, bookingWorkspace, jobCopyWindow, jobNoRuleSelector, BatchCheckingWindow, CheckingWindow },
  data() {
    return {
      loading: null,
      context: new RemoteBookingContext(),
      view: 'list',
      defaultSeaExportJob: null,
      defaultAirExportJob: null,
      defaultRailwayExportJob: null,
      defalutOpDepartmentMap: new Map(),
      copyDialog: {
        visible: false,
        job: {}
      },
      jobNoRule: {
        visible: false,
        rules: ''
      },
      railwayLobDialog: { // 业务类型选择弹窗
        visible: false,
        lob: 'RE',
        row: null
      },
      checkRow: new Job().fillDefaultValue().getData(),
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      checkingWindow: {
        visible: false,
        checkNode: 0,
        callBack: null,
        callBack2: null
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const params = to.params
      if (params.view) {
        vm.view = params.view
        const job = params.job || {}
        if (vm.view === 'detail' && params.source === SystemConstants.INTELLIGENT_DOCUMENT_SOURCE_REMOTE_SE.code) {
          job.containerLoadType = job.containerLoadType || 'FCL'
          job.freightTerm = job.freightTerm || 'CY-CY'
          job.freightTermHBL = job.freightTermHBL || 'CY-CY'
          job.bookingTerm = job.bookingTerm || 'OS'
          job.cargoSource = job.cargoSource || 'SC'
          job.cargoType = job.cargoType || 'GC'
          job.currency = job.currency || 'RMB'
          job.jobState = -1
          job.preverifyState = 4 // 预审状态默认为4暂不提交
          job.opOffice = vm.$store.getters.currentOfficeId
          job.parentUuid = ''
          job.path = ''
          vm.$refs.bookingWorkspace.onShow(params.action, [], job)
          delete params.view
          return
        }
        if (vm.view === 'detail' && params.source === 'webAccept') {
          // 官网订单接单（webAccept）：accept 已返回映射的 SeaExportJobDetailVO（含收发通/箱型/CIF门点/customerId）
          job.lob = job.lob || 'SE'
          job.containerLoadType = job.containerLoadType || 'FCL'
          job.freightTerm = job.freightTerm || 'CY-CY'
          job.freightTermHBL = job.freightTermHBL || 'CY-CY'
          job.bookingTerm = job.bookingTerm || 'OS'
          job.cargoSource = job.cargoSource || 'SC'
          job.cargoType = job.cargoType || 'GC'
          job.currency = job.currency || 'RMB'
          job.jobState = -1
          job.preverifyState = 4 // 暂不提交（保存成功后由 webAccept 钩子自动提交预审）
          job.opOffice = vm.$store.getters.currentOfficeId
          job.parentUuid = ''
          job.path = ''
          vm.$refs.bookingWorkspace.onShow(params.action, [], job)
          // 记录来源官网订单，供 bookingWorkspace 保存成功后 acceptCallback 回写（状态=已接单）
          vm.$refs.bookingWorkspace.webAcceptSourceOrderId = job.webAcceptSourceOrderId || ''
          delete params.view
          return
        }
        if (vm.view === 'detail' && params.source === SystemConstants.INTELLIGENT_DOCUMENT_SOURCE_REMOTE_AE.code) {
          job.jobState = -1
          job.preverifyState = 4 // 预审状态默认为4暂不提交
          job.opOffice = vm.$store.getters.currentOfficeId
          job.parentUuid = ''
          job.path = ''
          vm.$refs.bookingWorkspace.onShow(params.action, [], job)
          delete params.view
          return
        }
        if (vm.view === 'detail') {
          delete params.view
          vm.$refs.bookingWorkspace.createRemoteBooking(params.action, job, params.from)
        }
      }
    })
  },
  errorCaptured(err) {
    if (err instanceof ErrorTip) {
      this.$message({ message: err.message, type: err.type })
      return false
    }
    return true
  },
  computed: {
    // 深圳丰收销售专用
    isSalesForSzfs() {
      return String(cache.config.get('ToExoSystem')) === 'SZFS' && !this.$store.getters.isAdmin &&
        (this.$checkPermission(['role_salesOfGoods']) || this.$checkPermission(['role_RemoteBooking_queryPrivateCustom']) ||
          this.$checkPermission(['role_platform_sales']) || this.$checkPermission(['role_branchSales']) || this.$checkPermission(['role_sales']))
    },
    isHc() {
      return cache.config ? String(cache.config.get('ToExoSystem')) === 'HC' : false
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.SEQuantityWeightCubageRule = Number(cache.config.get('SEQuantityWeightCubageRule'))
    if (this.$route.query.jobNo && this.$refs.bookingTreeGrid) {
      this.$refs.bookingTreeGrid.toSimpleQuery(this.$route.query.jobNo)
    }
  },
  activated() {
    if (this.$route.query.jobNo) {
      this.toDetail(this, this.$route.query.jobNo)
      location.replace(location.href.replace(location.hash, `#${this.$route.path}`))
    }
  },
  methods: {
    lookHandle(row) {
      this.detailHandle('look', row)
    },
    async editHandle(row) {
      if (!(await SecurityUtil.canEdit(row))) {
        this.$message.info(this.$t('Message.YouPermissionToEditNotes'))
        return
      }
      await Promise.all([this.context.prepareData(), this.getDefaultJobValue()])
      if (row.preverifyState === SystemConstants.VERIFYING_PENDING.code && this.context.config.get('RemoteBookingCommitedEditable') !== '1') {
        this.$message.warning(this.$t('CargoMsg.Cargo_BURCNBE'))
        return
      }
      // 已审核，复核通过，复核拒绝的业务不能编辑
      if ([SystemConstants.VERIFYING_AUDITED.code, SystemConstants.VERIFYING_REVIEW_THROUGH.code,
        SystemConstants.VERIFYING_REVIEW_REFUSAL.code].includes(row.preverifyState)) {
        const stateStr = JobUtils.getStateName(row.preverifyState, SystemConstants.REMOTE_BOOKING_ALL_STATES)
        this.$message.warning(this.$t('Message.CanNotEditJob', [stateStr]))
        return
      }
      this.detailHandle('edit', row)
    },
    copyHandle(row) {
      if (JobUtils.checkHQ()) { return }
      if (row.customerId) {
        this.loading = getLoading()
        isContractExpiredForbidCreateJob(row.customerId).then(res => {
          this.loading.close()
          if (res.data) {
            this.$message.info(this.$t('Message.ContractExpireCannotCreated'))
          } else {
            this.copyDialog.job = row
            const isShowView = LocalStorageUtils.getConfiguration('COPY_JOB_remoteBooking') // 是否显示复制选项弹框【勾选是true不显示】
            if (!isShowView) {
              this.copyDialog.visible = true
            } else {
              this.doCopyJob()
            }
          }
        })
      }
    },
    doCopyJob() {
      const item = {}
      item.jobRule = ''
      item.jobUuid = this.copyDialog.job.uuid
      item.branchId = this.$store.getters.currentOfficeId
      /* 复制哪些页签的数据 */
      item.vesselEq = false
      item.mbl = false
      item.hbl = false
      item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_remoteBooking')
      item.prePlanBooking = false
      item.copyNum = LocalStorageUtils.getConfiguration('COPY_NUM_INPUTremoteBooking')
      const notMatchAgainSelect = LocalStorageUtilsNew.getConfiguration('NOT_MATCH_AGAIN_SELECT_remoteBooking')
      item.all = false
      item.source = 'remoteBooking'
      this.loading = getLoading()
      let doCopyJob = null
      switch (this.copyDialog.job.lob) {
        case 'SE':
          doCopyJob = doCopySeJob
          break
        case 'AE':
          doCopyJob = doCopyAeJob
          break
        case 'RE':
        case 'RI':
          doCopyJob = doCopyRailwayJob
      }
      const localCurrency = RateUtil.localCurrencyByOffice()
      doCopyJob(item).then(async res => {
        const sourceJob = this.copyDialog.job
        const newJob = res.data
        newJob.jobState = -1
        newJob.preverifyState = 4 // 预审状态默认为4暂不提交
        newJob.opOffice = this.$store.getters.currentOfficeId
        // 复制时以下字段不复制：订舱代理、船公司、船公司约号、船代
        newJob.bookingAgent = 0
        newJob.carrierId = 0
        newJob.scNo = ''
        newJob.carrierAgentId = 0
        if (sourceJob.lob === 'SE') {
          newJob.ams = false
          newJob.heating = false
          newJob.comercialInspectation = false
          newJob.customs = false
          newJob.signMBL = false
          newJob.signHBL = false
          newJob.mblOnly = false
          newJob.salePrice = false
          newJob.etd = sourceJob.etd
          newJob.soNo = ''
          newJob.bookingNo = ''
          newJob.returnPeriodBegin = ''
          newJob.returnPeriodEnd = ''
          newJob.fileCutoff = ''
          if ([1, 2].indexOf(this.SEQuantityWeightCubageRule) === -1) {
            newJob.quantityActual = 0
            newJob.weightActual = 0
            newJob.cubageActual = 0
          }
          newJob.customsBroker = 0
          newJob.trucking = []
          newJob.carryingCmp = 0
        } else if (sourceJob.lob === 'AE') {
          if (!newJob.sellingCurrency || newJob.sellingCurrency.length === 0) {
            newJob.sellingCurrency = localCurrency
          }
          if (!newJob.buyingCurrency || newJob.buyingCurrency.length === 0) {
            newJob.buyingCurrency = localCurrency
          }
        } else if (sourceJob.lob === 'RE' || sourceJob.lob === 'RI') {
          newJob.soNo = ''
          newJob.bookingNo = ''
          newJob.returnPeriodBegin = ''
          newJob.returnPeriodEnd = ''
          newJob.fileCutoff = ''
        }
        const continueExec = await JobUtils.validateJobFieldActive(newJob, this)
        if (!continueExec) {
          return
        }
        await JobUtils.doNotMatchAgainSelect(newJob, notMatchAgainSelect)
        this.detailHandle('copy', newJob)
      }).finally(() => {
        this.loading.close()
      })
    },
    async addHandle(row) {
      if (JobUtils.checkHQ()) { return }
      row.taxNature = 0
      await this.getDefaultJobValue()
      if (row.lob === 'SE') {
        new SeaExportJob(row).fillDefaultValue()
        row.containerLoadType = row.containerLoadType || 'FCL'
        row.freightTerm = 'CY-CY'
        row.freightTermHBL = 'CY-CY'
        row.bookingTerm = 'OS'
        row.cargoSource = 'SC'
        row.cargoType = 'GC'
        row.currency = 'RMB'
        Object.assign(row, this.defaultSeaExportJob)
      } else if (row.lob === 'AE') {
        new AirExportJob(row).fillDefaultValue()
        const localCurrency = await RateUtil.localCurrencyByOffice()
        row.bookingTerm = 'SB'
        row.cargoSource = 'SC'
        row.cargoType = 'GC'
        row.currency = 'RMB'
        Object.assign(row, this.defaultAirExportJob)
        if (!row.sellingCurrency || row.sellingCurrency.length === 0) {
          row.sellingCurrency = localCurrency
        }
        if (!row.buyingCurrency || row.buyingCurrency.length === 0) {
          row.buyingCurrency = localCurrency
        }
      } else if (row.lob === 'RE' || row.lob === 'RI') {
        new RailwayExportJob(row).fillDefaultValue()
        row.cargoType = 'GC'
        row.cargoSource = 'NC'
        const opDepartment = await this.getOpDepartment(this.$store.getters.currentOfficeId)
        const user = this.context.user
        if (opDepartment && Number(opDepartment.departmentId) > 0) {
          row.op = user.userId
          if (user.defaultDepId > 0 && user.defaultOfficeId === this.$store.getters.currentOfficeId) {
            row.opDepartment = user.defaultDepId
          } else {
            row.opDepartment = opDepartment.departmentId
          }
        }
        row.containerLoadType = 'FCL'
        row.tradeTerm = '110'
        Object.assign(row, this.defaultRailwayExportJob)
      } else {
        return
      }
      row.jobState = -1
      row.preverifyState = 4 // 预审状态默认为4暂不提交
      row.opOffice = this.$store.getters.currentOfficeId
      if (row.lob === 'RE' || row.lob === 'RI') {
        row.landTransportation = true
        this.railwayLobDialog.lob = 'RE'
        this.railwayLobDialog.row = row
        this.railwayLobDialog.visible = true
      } else {
        this.detailHandle('add', row)
      }
    },
    async getDefaultJobValue() {
      const entityDefValUtil = EntityDefaultValueUtil.getInstance()
      if (!entityDefValUtil.defaultValues) {
        await entityDefValUtil.initEntityDefaultValue()
      }
      this.defaultSeaExportJob = entityDefValUtil.seaExportJob.getData()
      this.defaultAirExportJob = entityDefValUtil.airExportJob.getData()
      this.defaultRailwayExportJob = entityDefValUtil.railwayExportJob.getData()
    },
    async getOpDepartment(officeId) {
      let opDepartment = this.defalutOpDepartmentMap.get(officeId)
      if (!opDepartment) {
        opDepartment = await getUserDefaultDepartment({ category: 'role', shape: 'op', userId: 0, officeId }).then(res => res.data)
        this.defalutOpDepartmentMap.set(officeId, opDepartment)
      }
      return opDepartment
    },
    confirmRailwayLobHandler() {
      this.railwayLobDialog.visible = false
      this.railwayLobDialog.row.lob = this.railwayLobDialog.lob
      this.detailHandle('add', this.railwayLobDialog.row)
    },
    // 进详情处理
    detailHandle(type, row) {
      let rowData = null
      if (this.view === 'detail') {
        rowData = this.$refs.bookingWorkspace.rowData
      } else {
        this.view = 'detail'
        rowData = this.$refs.bookingTreeGrid.rowData
      }
      if (this.$refs.bookingWorkspace) {
        this.$refs.bookingWorkspace.onShow(type, rowData, row)
      } else {
        this.$nextTick(() => {
          this.$refs.bookingWorkspace.onShow(type, rowData, row)
        })
      }
    },
    lockFormEvent(data) {
      if (!data) {
        this.$message.info(this.$t('CargoMsg.Cargo_PleaseSelectAPieceOfData'))
        return
      }
      if (data.preverifyState !== 1) {
        this.$message.info(this.$t('CargoMsg.Cargo_StatusIsNotPending'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureToHoldSubmission'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('constant.yes'),
        cancelButtonText: this.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        const job = { ...data }
        for (const key in job) {
          if (typeof job[key] === 'object') {
            delete job[key]
          }
        }
        job.preverifyState = 4
        // 保存到数据库
        let saveFunc = null
        switch (job.lob) {
          case 'SE':
            saveFunc = saveSeaBookingSpace
            break
          case 'AE':
            saveFunc = saveAeBookingSpace
            break
          case 'RE':
          case 'RI':
            saveFunc = saveRailwayExport
            break
        }
        saveFunc({ job, source: 'remoteBooking-notYetSubmitted' }).then(res => {
          if (res.data.job) {
            Object.assign(data, res.data.job)
            this.$refs.bookingTreeGrid.gridApi.refreshCells({ force: true })
          }
          this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
        })
      }).catch()
    },
    lockFormEventBatch(data) {
      if (!data || data.length === 0) {
        this.$message.info(this.$t('CargoMsg.Cargo_SelectAtLeastOneRecord'))
        return
      }
      const errorData = []
      data.forEach(item => {
        if (item.preverifyState !== 1) {
          errorData.push(item)
          return
        }
      })
      if (errorData.length > 0) {
        this.$message.info(this.$t('CargoMsg.Cargo_SelectDataIsNotAuditState'))
        return
      }
      const keys = []
      this.$confirm(this.$t('CargoMsg.Cargo_SureToHoldSubmission'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('constant.yes'),
        cancelButtonText: this.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        data.forEach(item => {
          keys.push(item.uuid)
        })
        // preverifyState = 4 暂不提交
        batchUpdatePreVerifyState(keys, 4).then(res => {
          this.$refs.bookingTreeGrid.toAdvancedQuery()
          this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
        })
      }).catch()
    },
    async submitFormEvent(data) {
      if (!data) {
        this.$message.info(this.$t('CargoMsg.Cargo_PleaseSelectAPieceOfData'))
        return
      }
      if (data.preverifyState === 1 || data.preverifyState === 2) {
        this.$message.info(this.$t('CargoMsg.Cargo_NotSubmittedAndRejectedStatusTips'))
        return
      }
      await this.context.prepareData()
      // 判断是否开启验证规则
      const useCheckRule = Number(this.context.config.get('useCheckRule')) === 1
      const hasCheckRule = true
      if (useCheckRule && hasCheckRule) {
        this.checkRow = data
        this.checkingManager(CheckRuleConstants.NODE_REMOTE_BOOKING.code, () => {
          this.submitPreverifyState(data)
        }, null)
      } else {
        this.$confirm(this.$t('CargoMsg.Cargo_subimitPreStatusTips'), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('constant.yes'),
          cancelButtonText: this.$t('constant.no'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.submitPreverifyState(data)
        }).catch()
      }
    },
    async submitFormEventBatch(data) {
      if (!data || data.length === 0) {
        this.$message.info(this.$t('CargoMsg.Cargo_SelectAtLeastOneRecord'))
        return
      }
      const errorData = []
      data.forEach(item => {
        if (item.preverifyState === 1 || item.preverifyState === 2 || item.preverifyState === 5 || item.preverifyState === 7) {
          errorData.push(item)
          return
        }
      })
      if (errorData.length > 0) {
        this.$message.info(this.$t('CargoMsg.Cargo_SelectDataIsNotSubmittedTemporarilyOrRejectState'))
        return
      }
      await this.context.prepareData()
      // 判断是否开启验证规则
      const useCheckRule = Number(this.context.config.get('useCheckRule')) === 1
      const hasCheckRule = true
      if (useCheckRule && hasCheckRule) {
        this.checkRow = data
        this.checkingManagerBatch(data, CheckRuleConstants.NODE_REMOTE_BOOKING.code, () => {
          this.submitPreverifyStateBatch(data)
        }, null)
      } else {
        this.$confirm(this.$t('CargoMsg.Cargo_subimitPreStatusTips'), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('constant.yes'),
          cancelButtonText: this.$t('constant.no'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.submitPreverifyStateBatch(data)
        }).catch()
      }
    },
    // 验证规则配置公用
    checkingManager(checkNode, callBack, callBack2) {
      let checkType = true
      if (this.checkRow.masterFlag) {
        const lclSlaves = this.checkRow.lclSlaves
        if (lclSlaves && lclSlaves.length > 0) { // 批量验证
          checkType = false
          this.batchCheckingWindow.checkNode = checkNode
          this.batchCheckingWindow.jobs = [this.checkRow, ...lclSlaves]
          this.batchCheckingWindow.callBack = callBack
          this.batchCheckingWindow.callBack2 = callBack2
          this.batchCheckingWindow.visible = true
        }
      }
      if (checkType) { // 单个验证
        this.checkingWindow.checkNode = checkNode
        this.checkingWindow.callBack = callBack
        this.checkingWindow.callBack2 = callBack2
        this.checkingWindow.visible = true
      }
    },
    checkingManagerBatch(jobs, checkNode, callBack, callBack2, allowPartialCheckPass = false) {
      if (jobs && jobs.length > 0) { // 批量验证
        this.batchCheckingWindow.checkNode = checkNode
        this.batchCheckingWindow.jobs = jobs
        this.batchCheckingWindow.allowPartialCheckPass = allowPartialCheckPass
        this.batchCheckingWindow.callBack = callBack
        this.batchCheckingWindow.callBack2 = callBack2
        this.batchCheckingWindow.visible = true
      }
    },
    submitPreverifyState(data) {
      const job = { ...data }
      for (const key in job) {
        if (typeof job[key] === 'object') {
          delete job[key]
        }
      }
      // 没有干线 或者 是FOB 直接进入正式业务
      if (this.isHc && data.lob === 'SE' && data.incoTerm === 'FOB') {
        // CARGO-52330 通过询报价功能可直接跳转至操作模块
        job.jobState = 0
        job.preverifyState = 2
      } else {
        job.jobState = -1
        job.preverifyState = 1
      }
      // 保存到数据库
      let saveFunc = null
      switch (job.lob) {
        case 'SE':
          saveFunc = saveSeaBookingSpace
          break
        case 'AE':
          // 小物件同步
          if (job.insideQuantity) {
            job.slac = job.insideQuantity
          }
          saveFunc = saveAeBookingSpace
          break
        case 'RE':
        case 'RI':
          saveFunc = saveRailwayExport
          break
      }
      saveFunc({ job, source: 'remoteBooking-submitJob' }).then(res => {
        if (res.data.job) {
          Object.assign(data, res.data.job)
          this.$refs.bookingTreeGrid.gridApi.refreshCells({ force: true })
        }
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
      })
    },
    submitPreverifyStateBatch(data) {
      const keys = []
      data.forEach(item => {
        for (const key in item) {
          if (typeof item[key] === 'object') {
            delete item[key]
          }
        }
        keys.push(item.uuid)
      })
      // PreVerifyState为1 待审核状态  jobState为-1 不可操作
      batchUpdatePreVerifyStateAndJobState(keys, 1, -1, this.$store.getters.currentOfficeId).then(res => {
        this.$refs.bookingTreeGrid.toAdvancedQuery()
        this.$message.success(this.$t('CargoMsg.Cargo_SubmittedSuccessfully'))
      })
    },
    backToList(isRefresh) {
      this.view = 'list'
      if (isRefresh) {
        const bookingTreeGridRef = this.$refs.bookingTreeGrid
        if (bookingTreeGridRef.filter.conditions.length > 0) {
          bookingTreeGridRef.toQuery()
        } else {
          bookingTreeGridRef.rowData = this.$refs.bookingWorkspace.rowData
        }
      }
    },
    // 查询job后跳转详情
    toDetail(vm, jobNo) {
      const params = {}
      params.branchId = vm.$store.getters.currentOfficeId
      params.jobNo = jobNo
      params.pageNum = 1
      vm.view = 'detail'
      const loading = getLoading4Cxt(this)
      params.conditions = [new AdvancedSearchOption(null, 'job.JOB_NO', jobNo, '=').formatObj2Json()]
      remoteBookingQuery(params).then(res => {
        const rowData = this.getNewDetailData(res.data.list)
        if (rowData.length !== 0) {
          vm.$refs.bookingTreeGrid.rowData = rowData
          const index = rowData.findIndex(p => p.jobNo === jobNo)
          if (index > 0) {
            vm.$refs.bookingWorkspace.onShow('look', rowData, rowData[index])
          } else {
            vm.$refs.bookingWorkspace.onShow('look', rowData, rowData[0])
          }
        } else {
          vm.$message.error(this.$t('Message.NoRecordMeetTheConditions'))
          vm.$refs.bookingWorkspace.goBack()
        }
      }).catch(() => {
        vm.$message.error(this.$t('Message.JumpFailed'))
      }).finally(() => {
        loading.close()
      })
    },
    getNewDetailData(rowData) {
      rowData = lodash.cloneDeep(rowData)
      for (const item of rowData) {
        new Job(item).fillDefaultValue() // 数据补充完整
        item.version = 0 // 版本号置为0，重新加载job
      }
      return rowData
    }
  }
}
</script>
